import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space } from "@masterteam/mt-design-react";

import { ReactComponent as ReminderIcon } from "../../../assets/images/reminder.svg";
import { ReactComponent as NewTaskIcon } from "../../../assets/images/newtask.svg";
import { ReactComponent as EscalationIcon } from "../../../assets/images/escalation.svg";
import { ReactComponent as ArrowLeftIcon } from "../../../assets/images/arrow-right.svg";
import { ReactComponent as ArrowRightIcon } from "../../../assets/images/arrow-left.svg";
import { ReactComponent as DoneIcon } from "../../../assets/images/check.svg";
import { ReactComponent as RejectIcon } from "../../../assets/images/rejected.svg";
import { ReactComponent as DelegateIcon } from "../../../assets/images/delegate.svg";

import useIsAr from "../../../Hooks/useIsAr";

import styles from "./NotificationItem.module.scss";

const notificationsTypes = {
  Reminder: {
    type: "Reminder",
    icon: <ReminderIcon />,
    title: "notification-type.reminder",
  },
  Escalation: {
    type: "Escalation",
    icon: <EscalationIcon />,
    title: "notification-type.escalation",
  },
  NewTask: {
    type: "NewTask",
    icon: <NewTaskIcon />,
    title: "notification-type.new-task",
  },
  Approval: {
    type: "Approval",
    icon: <DoneIcon />,
    title: "notification-type.approval",
  },
  Rejection: {
    type: "Rejection",
    icon: <RejectIcon />,
    title: "notification-type.rejection",
  },
  Delegation: {
    type: "Delegation",
    icon: <DelegateIcon />,
    title: "header-delegation",
    path: "/splus/delegations",
  },
};

function NotificationItem({ item, onClick }) {
  const type = item?.NotificationType;
  const [isAr] = useIsAr();

  return (
    <Row
      justify="between"
      align="center"
      size="medium"
      className={`animated fadeInLeft  ${styles.notificationItem} ${
        item.Status === "1" && styles.notRead
      }`}
      onClick={() => onClick(item, notificationsTypes?.[type])}
    >
      {notificationsTypes?.[type] && (
        <>
          <Space size="medium">
            <div className={styles.notificationIcon}>
              {notificationsTypes?.[type]?.icon}
            </div>
            <div className="text-normal">
              <div className="bold">
                <FormattedMessage
                  id={notificationsTypes[type].title}
                  defaultMessage={notificationsTypes[type].title}
                />
              </div>
              {isAr ? item?.ArabicName : item?.EnglishName}
            </div>
          </Space>
          <span className={styles.arrowIcon}>
            {isAr ? <ArrowRightIcon /> : <ArrowLeftIcon />}
          </span>
        </>
      )}
    </Row>
  );
}

export default NotificationItem;
